export default __webpack_public_path__ + "static/media/project3.ec8317e4.png";